<template>
  <div class="air-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      <el-breadcrumb-item>空调伴侣</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="设备编号">
          <el-input v-model="formInline.device_sn" placeholder="请输入设备编号" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="店铺ID">
          <el-input v-model="formInline.shop_id" placeholder="请输入店铺ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="台桌ID">
          <el-input v-model="formInline.table_id" placeholder="请输入台桌ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" placeholder="请选择状态" clearable>
            <el-option label="在线" value="1"></el-option>
            <el-option label="离线" value="0"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="onSubmit" icon="el-icon-search">查询</el-button>
          <el-button @click="resetSearchForm" icon="el-icon-refresh">重置</el-button>
          <el-button type="success" @click="handleAdd" icon="el-icon-plus">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      style="width: 100%"
      stripe>
      <el-table-column prop="device_sn" label="设备编号" min-width="150" align="center"></el-table-column>
      </el-table-column>
            <el-table-column prop="shop_name" label="店铺名称" min-width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.shop_name || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="table_name" label="台桌名称" min-width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.table_name || '-' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="shop_id" label="店铺ID" min-width="120" align="center"></el-table-column>
      <el-table-column prop="table_id" label="台桌ID" min-width="120" align="center"></el-table-column> -->
      <el-table-column prop="is_open" label="是否控制订单常开" min-width="120" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_open === 1 ? 'success' : 'info'">
            {{ scope.row.is_open === 1 ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="mode" label="模式" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="getModeType(scope.row.mode)">
            {{ getModeText(scope.row.mode) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="temp" label="温度" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.temp }}°C
        </template>
      </el-table-column>

      <!-- <el-table-column prop="status" label="状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '在线' : '离线' }}
          </el-tag>
        </template>
      </el-table-column> -->

      <el-table-column fixed="right" label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="resetDialogForm">
      <el-form :model="form" :rules="rules" ref="airForm" label-width="120px">
        <el-form-item label="设备编号" prop="device_sn">
          <el-input v-model="form.device_sn" placeholder="请输入设备编号"></el-input>
        </el-form-item>

        <el-form-item label="选择店铺" prop="shop_id">
          <el-select 
            v-model="form.shop_id" 
            placeholder="请选择店铺"
            filterable
            remote
            :remote-method="searchShops"
            :loading="shopLoading"
            @change="handleShopChange"
            style="width: 100%">
            <el-option 
              v-for="item in shopOptions" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择台桌" prop="table_id">
          <el-select 
            v-model="form.table_id" 
            placeholder="请先选择店铺"
            :disabled="!form.shop_id"
            style="width: 100%"
            :multiple="!isEdit"
            filterable>
            <el-option 
              v-for="item in roomOptions" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="随订单常开" prop="is_open">
          <el-switch v-model="form.is_open" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="模式" prop="mode">
          <el-select v-model="form.mode" placeholder="请选择模式" style="width: 100%">
            <el-option label="自动模式" :value="0"></el-option>
            <el-option label="制冷模式" :value="1"></el-option>
            <el-option label="制热模式" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="温度" prop="temp">
          <el-input-number v-model="form.temp" :min="16" :max="30" style="width: 100%"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { air, addAir, editAir } from '@/api/device'
import { getShopList,getTableList } from '@/api/shop'

export default {
  name: 'Air',
  data() {
    return {
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      formInline: {
        device_sn: '',
        shop_id: '',
        table_id: '',
        status: ''
      },
      dialogVisible: false,
      dialogTitle: '',
      form: {
        device_sn: '',
        shop_id: '',
        table_id: '',
        is_open: 1,
        mode: 0,
        temp: 26,
        org_id:this.$globalConfig.orgId
      },
      originalForm: null, // 存储原始数据用于比较
      rules: {
        device_sn: [
          { required: true, message: '请输入设备编号', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        shop_id: [
          { required: true, message: '请选择店铺', trigger: 'change' }
        ],
        table_id: [
          { required: true, message: '请选择台桌', trigger: 'change' }
        ]
      },
      submitLoading: false,
      isEdit: false,
      org_id:this.$globalConfig.orgId,
      shopOptions: [],
      roomOptions: [],
      shopLoading: false
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          ...this.formInline
        }
        const res = await air(params)
        if (res.code === 1) {
          this.tableData = res.data.data || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.data.msg || '获取数据失败')
        }
      } catch (error) {
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    onSubmit() {
      this.currentPage = 1
      this.loadData()
    },
    resetSearchForm() {
      this.formInline = {
        device_sn: '',
        shop_id: '',
        table_id: '',
        status: ''
      }
      this.currentPage = 1 // 重置到第一页
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    async handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增空调伴侣'
      this.form = {
        device_sn: '',
        shop_id: '',
        table_id: [], // 新增模式：多选
        is_open: 1,
        mode: 0,
        temp: 26,
        org_id:this.$globalConfig.orgId
      }
      this.dialogVisible = true
      
      // 加载店铺列表
      await this.searchShops('')
    },
    
    async handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑空调伴侣'
      this.form = { 
        ...row,
        // 编辑模式台桌ID为单选，直接使用原始值
        table_id: row.table_id || ''
      }
      // 保存原始数据用于比较，确保数据类型一致
      this.originalForm = {
        device_sn: String(row.device_sn || ''),
        shop_id: String(row.shop_id || ''),
        table_id: String(row.table_id || ''),
        is_open: Number(row.is_open || 0),
        mode: Number(row.mode || 0),
        temp: Number(row.temp || 0)
      }
      this.dialogVisible = true
      
      // 加载店铺列表
      await this.searchShops('')
      
      // 如果对应行有绑定店铺，加载对应的台桌列表
      if (row.shop_id) {
        await this.loadRooms(row.shop_id)
      }
    },

    getModeText(mode) {
      const modeMap = {
        0: '自动模式',
        1: '制冷模式',
        2: '制热模式'
      }
      return modeMap[mode] || '未知'
    },
    getModeType(mode) {
      const typeMap = {
        0: 'info',
        1: 'primary',
        2: 'danger'
      }
      return typeMap[mode] || 'info'
    },
    submitForm() {
      this.$refs.airForm.validate(async (valid) => {
        if (valid) {
          // 编辑模式下检测字段变动
          if (this.isEdit && this.originalForm) {
            const hasChanged = this.checkFormChanged()
            if (!hasChanged) {
              this.$message.warning('编辑框未变动，无需提交')
              return
            }
          }
          
          this.submitLoading = true
          try {
            // 处理台桌数据格式
            const formData = { ...this.form }
            if (this.isEdit) {
              // 编辑模式：单选，直接使用原始值
              formData.table_id = formData.table_id
            } else {
              // 新增模式：多选，取第一个值或保持数组
              formData.table_id = Array.isArray(formData.table_id) ? formData.table_id[0] : formData.table_id
            }
            
            const api = this.isEdit ? editAir : addAir
            const res = await api(formData)
            if (res.data.code === 200) {
              this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(res.data.msg || '操作失败')
            }
          } catch (error) {
            this.$message.error('操作失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    },
    resetDialogForm() {
      this.$refs.airForm && this.$refs.airForm.resetFields()
    },
    // 关闭编辑弹框
    closeDialog(formName) {
      if (formName == 'editForm') {
        this.editFormVisible = false
      }
    },
    // 搜索店铺
    searchShops(query) {
      this.shopLoading = true
      const org = this.org_id;
      const params = {
        name: query,
        page: 1,
        limit: 100,
        org_id: org
      }
      getShopList(params).then(res => {
        this.shopLoading = false
        if (res.code === 1) {
          this.shopOptions = res.data || []
        } else {
          this.$message.error('获取店铺列表失败')
        }
      }).catch(() => {
        this.shopLoading = false
        this.$message.error('获取店铺列表失败')
      })
    },
    // 店铺变化时加载包厢
    handleShopChange(shopId) {
      this.form.table_id = []
      this.roomOptions = []
      if (shopId) {
        this.loadRooms(shopId)
      }
    },
    
    // 检测表单字段是否发生变化
    checkFormChanged() {
      if (!this.originalForm) return false
      
      // 将当前表单数据转换为一致类型
      const currentForm = {
        device_sn: String(this.form.device_sn || ''),
        shop_id: String(this.form.shop_id || ''),
        table_id: String(this.form.table_id || ''),
        is_open: Number(this.form.is_open || 0),
        mode: Number(this.form.mode || 0),
        temp: Number(this.form.temp || 0)
      }
      
      const originalForm = this.originalForm
      
      // 比较各个字段
      return (
        currentForm.device_sn !== originalForm.device_sn ||
        currentForm.shop_id !== originalForm.shop_id ||
        currentForm.table_id !== originalForm.table_id ||
        currentForm.is_open !== originalForm.is_open ||
        currentForm.mode !== originalForm.mode ||
        currentForm.temp !== originalForm.temp
      )
    },

    // 加载台桌列表
    async loadRooms(shopId) {
      if (!shopId) return
      
      try {
        this.loading = true
        const res = await getTableList({ shop_id: shopId })
        this.loading = false
        if (res.code === 1) {
          this.roomOptions = res.data || []
        } else {
          this.$message.error('获取台桌列表失败')
        }
      } catch (error) {
        this.loading = false
        this.$message.error('获取台桌列表失败')
      }
    }
  }
}
</script>

<style scoped>
.air-container {
  padding: 20px;
  background-color: #f5f5f5;
}

.search-bar {
  background: white;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.action-bar {
  background: white;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/device/Air.vue